import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, getToken, onMessage } from 'firebase/messaging';
import axios from 'axios';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'demo-key',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'demo.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'demo',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'demo.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '123456789',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:123456789:web:abc123',
};

let app = null;
let messaging = null;

// Initialize Firebase only if messaging is supported
const initializeFirebase = async () => {
  try {
    // Check if messaging is supported in this browser
    const messagingSupported = await isSupported();
    
    if (!messagingSupported) {
      console.info('Firebase Messaging not supported in this browser');
      return;
    }

    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
    console.info('Firebase Messaging initialized successfully');
  } catch (error) {
    console.warn('Firebase initialization failed:', error);
  }
};

// Initialize on module load
initializeFirebase();

export const requestNotificationPermission = async () => {
  try {
    if (!messaging) {
      console.info('Firebase messaging not available - notifications disabled');
      return null;
    }

    // Check if Notification API is available
    if (!('Notification' in window)) {
      console.info('Notification API not available');
      return null;
    }

    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || 'demo-vapid-key',
      });
      
      // Send token to backend
      const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
      await axios.post(`${API_URL}/auth/update-fcm-token`, { token });
      
      return token;
    }
    
    return null;
  } catch (error) {
    console.warn('Error getting notification token:', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }
    
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export default messaging;